import { gql } from 'graphql-request';

export default gql`
  query vmboxById($mask: String, $id: String) {
    vmboxById(mask: $mask, id: $id) {
      id
      account_id
      doc
      listing
      updatedAt
    }
  }
`;
